import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-audit-info',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './audit-info.component.html',
  styleUrls: ['./audit-info.component.scss'],
})
export class AuditInfoComponent {
  @Input() dateUtc!: Date | undefined;

  get dateLocal(): string | undefined {
    return this.dateUtc ? `${this.dateUtc}Z` : undefined;
  }
}
